$(document).ready(function () {

    $(document).on('click', '.add-to-cart-with-variants .add-to-cart-icon', function () {   
        var opton_size = $(this).attr('data-opton-size');
        opton_size = parseFloat(opton_size);
        $('.add-to-cart-icon').removeClass('main-add-to-cart-button');
        $(".add-to-cart-with-variants .add-to-cart-icon").prop('disabled', false);
        $(".product-options").hide();
        $('.add-to-cart-with-variants').removeClass('show-product-option');
        $(this).next().show();
        $(this).closest('.add-to-cart-with-variants').addClass('show-product-option');
        var opton_size = $(this).attr('data-size-option');
        var numbersize = $('.active-value').length;
        if (opton_size != numbersize) {
            $(this).prop('disabled', true);
            $('.all-product-Select').removeClass('selected-variant');
            $('.option-value').removeClass('active-value');
        }


      if(opton_size > 1){
         $(this).closest('.show-product-option').find('.all-product-Select').each(function () {
            var optionValue = $(this).attr('data-name');
            var variant_status = $(this).attr('data-stock-status');
            if (variant_status === 'yes') {


        $(".show-product-option .product-variants-1 .option-value").each(function() {
        var second_value = $(this).attr('data-value');
         if (optionValue.includes(second_value)) {
           $(this).removeClass('soldout');
            
        }else if(variant_status === 'no'){
           $(this).addClass('soldout');
        } 
         else {
        }
    });
              
        }        
        });

}else{

}
      
    });

  
  

    $(document).on('click', '.product-variants-1 .option-value', function () {
       $(".show-product-option .product-variants-2 .option-value").removeClass('soldout');
        $(".product-variants-1 .option-value").removeClass('active-value');
        $(this).addClass('active-value');
        var val_1 = $(this).attr('data-value');
        var val_2 = $('.product-variants-2 .active-value').attr('data-value');
        var val_3 = $('.product-variants-3 .active-value').attr('data-value');

        final_var = '';
        if (val_3) {
            var final_var = val_1 + '-' + val_2 + '-' + val_3;
        }
        else if (val_2) {
            var final_var = val_1 + '-' + val_2;
        }
        else {
            var final_var = val_1;
        }
        $(this).closest('.show-product-option').find('.all-product-Select').each(function () {
            var optionValue = $(this).attr('data-name');
            var variant_status = $(this).attr('data-stock-status');
            if (optionValue == final_var) {
                $(this).addClass('selected-variant');
            } else {
                $(this).removeClass('selected-variant');
            }

         $(".product-variants-2 .option-value").each(function() {
        var second_value = $(this).attr('data-value');
         if (optionValue.includes(val_1) && optionValue.includes(second_value) && variant_status === 'yes') {
           //  console.log('Both val_1 and second_value exist in', optionValue);
           // console.log('variant_status:', variant_status);
            
        }else if(optionValue.includes(val_1) && optionValue.includes(second_value) && variant_status === 'no'){
           $(this).addClass('soldout');
        } 
         else {
             
        }
    });
          
        });

        var opton_size = $(this).closest(".product-options").attr('data-opton-size');
        var numbersize = $('.active-value').length;
        if (opton_size == numbersize) {
            $(this).closest('.add-to-cart-with-variants').find('.add-to-cart-icon').prop('disabled', false);
            $(this).closest('.add-to-cart-with-variants').find('.add-to-cart-icon').addClass('main-add-to-cart-button');
        }
    });





  

    $(document).on('click', '.product-variants-2 .option-value', function () {
         $(".show-product-option .product-variants-2 .option-value").removeClass('active-value');
        $(this).addClass('active-value');
        var val_1 = $('.product-variants-1 .active-value').attr('data-value');
        var val_2 = $(this).attr('data-value');
        var val_3 = $('.product-variants-3 .active-value').attr('data-value');

        final_var = '';
        if (val_3) {
            var final_var = val_1 + '-' + val_2 + '-' + val_3;
        }
        else if (val_2) {
            var final_var = val_1 + '-' + val_2;
        }
        else {
            var final_var = val_2;
        }
        $(this).closest('.show-product-option').find('.all-product-Select').each(function () {
            var optionValue = $(this).attr('data-name');
            if (optionValue == final_var) {
                $(this).addClass('selected-variant');

            } else {
                $(this).removeClass('selected-variant');
            }   

               $(".product-variants-1 .option-value").each(function() {
        var second_value = $(this).attr('data-value');
         if (optionValue.includes(val_2) && optionValue.includes(second_value) && variant_status === 'yes') {
           //  console.log('Both val_2 and second_value exist in', optionValue);
           // console.log('variant_status:', variant_status);
            
        }else if(optionValue.includes(val_2) && optionValue.includes(second_value) && variant_status === 'no'){
           $(this).addClass('soldout');
        } 
         else {
             
        }
    });
          
        });
        var opton_size = $(this).closest(".product-options").attr('data-opton-size');
        var numbersize = $('.active-value').length;
       var variant_status = $(this).attr('data-stock-status');
        if (opton_size == numbersize) {
            $(this).closest('.add-to-cart-with-variants').find('.add-to-cart-icon').prop('disabled', false);
            $(this).closest('.add-to-cart-with-variants').find('.add-to-cart-icon').addClass('main-add-to-cart-button');
        }
    });

    $(document).on('click', '.product-variants-3 .option-value', function () {
        $(".product-variants-3 .option-value").removeClass('active-value');
        $(this).addClass('active-value');
        var val_1 = $('.product-variants-1 .active-value').attr('data-value');
        var val_2 = $('.product-variants-2 .active-value').attr('data-value');
        var val_3 = $(this).attr('data-value');

        final_var = '';
        if (val_3) {
            var final_var = val_1 + '-' + val_2 + '-' + val_3;
        }
        else if (val_2) {
            var final_var = val_1 + '-' + val_2;
        }
        else {
            var final_var = val_3;
        }
        $(this).closest('.show-product-option').find('.all-product-Select').each(function () {
            var optionValue = $(this).attr('data-name');
            if (optionValue == final_var) {
                $(this).addClass('selected-variant');

            } else {
                $(this).removeClass('selected-variant');
            }
        });
        var opton_size = $(this).closest(".product-options").attr('data-opton-size');
        var numbersize = $('.active-value').length;
        if (opton_size == numbersize) {
            $(this).closest('.add-to-cart-with-variants').find('.add-to-cart-icon').prop('disabled', false);
            $(this).closest('.add-to-cart-with-variants').find('.add-to-cart-icon').addClass('main-add-to-cart-button');
        }
    });

    $(document).on("click", ".main-add-to-cart-button", function (event) {
      const $this = $(this);
        event.preventDefault();
        var items = [];
        var variantId = $(".show-product-option .selected-variant").attr('data-id');
        var qty = 1;
        var item = {
            id: variantId,
            quantity: qty
        };
        items.push(item);
        jQuery.ajax({
            type: "POST",
            url: '/cart/add.js',
            data: JSON.stringify({ items: items }),
            contentType: "application/json",
            dataType: "json",
            success: function (response) {
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                $(".header-cart-icon").trigger('click');
                $(".product-options").hide();
                $(".add-to-cart-with-variants").removeClass('show-product-option');
                $(".option-value").removeClass('active-value');
            },
            error: function (xhr, status, error) {
              $this.closest(".product-card").find(".out-stock-variant-info").show();
            }
        });
    });

    $(".close-icon").click(function () {
        $(".out-stock-variant-info").hide();
    })

    $(document).mouseup(function (e) {

        if ($(e.target).closest('.product-option, .add-to-cart-icon ').length != 0) return false;
        $(".product-options").hide();
        $(".add-to-cart-with-variants").removeClass('show-product-option');
        $(".add-to-cart-with-variants .add-to-cart-icon").prop('disabled', false);
        $(".option-value").removeClass('active-value');
        $('.add-to-cart-icon').removeClass('main-add-to-cart-button');
        $(".out-stock-variant-info").hide();

    });

  // Account page slider

  $(".all-clubs").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		infinite: true,
        rtl: true,
		autoplay: false,
        dots: true,
        prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
	});

  
  $("#customer-note-subscribe").val("No");
  $("#subscribe_on_register").click(function(){
    if ($(this).prop('checked')==true){ 
      $("#customer-note-subscribe").val("Yes");
    }else{
      $("#customer-note-subscribe").val("No");
    }
  });
  
  
});
